export default __webpack_public_path__ + "6c952ee6990c35607abcdc2f8542f73a.jpg";